import { render, staticRenderFns } from "./HourglassSVG.vue?vue&type=template&id=0fd2a622&"
import script from "./HourglassSVG.vue?vue&type=script&lang=js&"
export * from "./HourglassSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports